// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__12xgm","rightLink":"Link_rightLink__2gULl"};